// src/App.js
import React, { useState } from 'react';
import axios from 'axios';
import '../styles/login.css'
import { useAuth } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';


function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem('token');

    const auth = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (token) {
            axios.post('https://kaskas.pro/poker-stats-server/api/validateToken', {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(response => {
                if (response.data && response.data.hasAccess) {
                    auth.login(token);
                    navigate('/Main');
                }
            }).catch(err => {
                console.log(err);
            })
        }
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('')
        try {
            const response = await axios.post('https://kaskas.pro/poker-stats-server/api/login', { username, password });
            if (response.data && response.data.accessToken) {
                auth.login(response.data.accessToken);
                localStorage.setItem('token', response.data.accessToken);
                setIsLoading(false);
                navigate('/Main');
            }
            else {
                setIsLoading(false);
                setError('Invalid username or password');
            }
        } catch (error) {
            setIsLoading(false);
            setError('Invalid username or password');
        }
    };

    return (
        <>
            <div className="login-container">
                <h2 className='title'>Login</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    {error && <p className="error-message">{error}</p>}
                    <Button variant={isLoading?'secondary':'primary'} disabled={isLoading} type="submit">Login</Button>

                </form>
            </div>
            {isLoading ? <div className='loaderWrapper'><div className='loader'></div></div> : null}
        </>
    );
}

export default Login;
